export const tsmtPartner = {
  seo: {
    title: "TSMT® × Bespire — Partneri program TSMT® terapeutáknak",
    description:
      "Hivatalos TSMT® × Bespire együttműködés. LTSZ integráció, 1. évben −40%, 2. évben −20% kedvezmény minden csomagra. Egy AI asszisztens a foglaláshoz, weboldalhoz, számlázáshoz és marketinghez.",
  },
  hero: {
    badge: "TSMT® × Bespire — hivatalos partner",
    title: "Bespire a TSMT® terapeutáknak — kedvezményesen",
    subtitle:
      "Teljes AI asszisztens TSMT® terapeutákra szabva: saját weboldal, online foglalás, számlázás és marketing egy helyen — LTSZ integrációval és partneri kedvezménnyel.",
    ctaPrimary: "Igénylés nyilvántartási számmal",
    ctaSecondary: "Ingyenes próba",
    imageAlt: "TSMT® terapeuta gyerekkel foglalkozik",
    stats: [
      { value: "−40%", label: "1. év kedvezmény" },
      { value: "−20%", label: "2. év kedvezmény" },
      { value: "LTSZ", label: "automatikus szinkron" },
    ],
  },
  whatIs: {
    heading: "Mi az a Bespire?",
    description:
      "Egy AI asszisztens, ami leveszi a válladról a rendelés körüli adminisztrációt — hogy a terápiás munkára tudj koncentrálni.",
    tiles: [
      {
        title: "Saját weboldal + online foglalás",
        description:
          "A klienseid a te weboldaladon (Bespire‑rel építve, 10 perc alatt kész) foglalnak időpontot — nincs külön app, nincs telepítés.",
      },
      {
        title: "Marketing automatizáció",
        description:
          "AI segít a Facebook, Instagram és TikTok posztokban, hirdetésekben, heti tartalomtervben — nem kell külön marketinges.",
      },
      {
        title: "Ügyfél‑ és bevétel‑admin",
        description:
          "Bérletek, csomagok, számlázz.hu integráció, kártyás online fizetés — egyben, átláthatóan.",
      },
    ],
  },
  partnership: {
    heading: "A TSMT® × Bespire együttműködés",
    description:
      "Hivatalos stratégiai partnerség a TSMT®‑vel. A cél egyszerű: kevesebb adminisztráció, hatékonyabb online jelenlét — kedvezőbb áron azoknak, akik hivatalos TSMT® terapeuták.",
    eligibilityLabel: "Ki jogosult",
    eligibility:
      "Minden érvényes TSMT® nyilvántartási számmal rendelkező terapeuta — havi és éves fizetésnél egyaránt.",
  },
  ltsz: {
    badge: "Beépített integráció",
    title: "Össze van kötve az LTSZ‑szel",
    description:
      "A Bespire AI asszisztens integrálva van az LTSZ‑szel. A weboldaladon lefoglalt időpontok automatikusan megjelennek az LTSZ‑ben is — nem kell duplán adminisztrálnod.",
    highlight: "Egyszer rögzül, két helyen látszik.",
    steps: [
      {
        title: "1. Foglalás a saját weboldaladon",
        description:
          "A kliens időpontot foglal a te Bespire‑rel épített weboldaladon.",
      },
      {
        title: "2. Automatikus szinkron",
        description:
          "Az időpont a háttérben átkerül az LTSZ‑be — kattintás nélkül.",
      },
      {
        title: "3. Minden a helyén",
        description:
          "Az LTSZ‑ben pontosan úgy jelenik meg, ahogy kell — nulla manuális bevitel.",
      },
    ],
    imageAlt: "LTSZ időpontlista — a weboldaladról érkező foglalások automatikusan megjelennek",
  },
  discount: {
    heading: "TSMT® partneri kedvezmény",
    subheading: "Csak érvényes nyilvántartási számmal rendelkező terapeutáknak.",
    year1Label: "1. év",
    year1Value: "−40%",
    year2Label: "2. év",
    year2Value: "−20%",
    note: "Nettó árak, + ÁFA. Éves fizetésnél 2 hónapot elengedünk (havi × 10), és ez kombinálható a TSMT® partneri kedvezménnyel. A kedvezményt a TSMT®‑nyilvántartási szám alapján igazoljuk.",
    cta: "Igénylés nyilvántartási számmal",
  },
  packages: {
    eyebrow: "Csomagok TSMT® áron",
    heading: "Válaszd ki, melyik csomag illik hozzád",
    subheading:
      "Havi vagy éves előfizetés — és rá jön a TSMT® partneri kedvezmény. Nettó árak, + ÁFA.",
    trialNote: "3 napig ingyen kipróbálhatod · AI-asszisztens a próba alatt · Kártya nem szükséges",
    recommended: "Ajánlott",
    ctaPrimary: "Kipróbálom ingyen",
    ctaSecondary: "Kérek visszahívást",
    perMonth: "/ hó",
    priceSuffix: " Ft + ÁFA",
    basePriceLabel: "Listaár",
    tsmtBadge: "TSMT® partneri kedvezmény",
    year1Label: "1. év (−40%)",
    year2Label: "2. év (−20%)",
    annualSavingLabel: "Kedvezmény évente",
    savingLabel: "Megtakarítás",
    perMonthShort: "/ hó",
    perYearShort: "/ év",
    billingToggle: {
      monthly: "Havi",
      annual: "Éves",
      saveBadge: "2 hónap ingyen",
      annualHint: "Éves fizetésnél 2 hónapot elengedünk (havi × 10) — erre jön rá a TSMT® partneri kedvezmény.",
    },
    items: [
      {
        name: "Standard",
        credits: "AI-asszisztens a napi munkához — a csomag részeként",
        features: [
          "Saját weboldal + online foglalás",
          "LTSZ automatikus szinkron",
          "Számlázás és kártyás fizetés",
          "AI marketing asszisztens",
        ],
        monthly: {
          base: "13 900 Ft + ÁFA",
          year1: "8 340 Ft + ÁFA",
          year2: "11 120 Ft + ÁFA",
          year1SavingPerMonth: "5 560 Ft + ÁFA",
        },
        annual: {
          base: "11 583 Ft + ÁFA",
          year1: "6 950 Ft + ÁFA",
          year2: "9 266 Ft + ÁFA",
          year1Saving: "55 600 Ft + ÁFA",
          year2Saving: "27 800 Ft + ÁFA",
          perYearLabel: "Éves díj listaáron: 139 000 Ft + ÁFA",
        },
      },
      {
        name: "Pro",
        credits: "AI-asszisztens a napi munkához — a csomag részeként",
        features: [
          "Minden, ami a Növekedésben — intenzívebb terapeuta-munkára optimalizálva",
          "Több felhasználó és helyszín — gördülékeny működés nagyobb forgalomban",
          "Prioritásos AI és marketing támogatás — gyorsabb válaszidő intenzív használathoz",
          "Elsőbbségi ügyfélszolgálat — prioritásos segítség a napi munkádhoz",
        ],
        monthly: {
          base: "24 900 Ft + ÁFA",
          year1: "14 940 Ft + ÁFA",
          year2: "19 920 Ft + ÁFA",
          year1SavingPerMonth: "9 960 Ft + ÁFA",
        },
        annual: {
          base: "20 750 Ft + ÁFA",
          year1: "12 450 Ft + ÁFA",
          year2: "16 600 Ft + ÁFA",
          year1Saving: "99 600 Ft + ÁFA",
          year2Saving: "49 800 Ft + ÁFA",
          perYearLabel: "Éves díj listaáron: 249 000 Ft + ÁFA",
        },
      },
    ],
  },
  aiCredits: {
    badge: "AI-asszisztens a csomagban",
    title: "AI-asszisztens a napi munkához — a csomag részeként",
    subtitle:
      "Az AI-asszisztens és minden AI-generálás (szöveg, kép, weboldal) a napi munkádhoz — a csomagod részeként. Nincs külön AI-díj, nincs kreditszámlálás.",
    whatIsTitle: "Mit jelent, hogy a csomag része?",
    whatIsDescription:
      "A csomagod díja tartalmazza az AI-asszisztens és az AI-generálás napi használatát a normál üzleti működéshez. Kampányidőszakban, nagyobb terhelésnél vagy extrém, automatizált használatnál extra kapacitás igényelhető.",
    examplesTitle: "Így használhatod nap mint nap",
    examples: [
      {
        task: "Social poszt generálása",
        credits: "Napi feladat",
        description: "Egy Instagram vagy Facebook poszt szöveggel és képpel a TSMT® gyakorlataidhoz.",
      },
      {
        task: "Weboldal szöveg írása",
        credits: "Rendszeres",
        description: "Szolgáltatásleírás, bemutatkozás vagy új oldal szövege az oldaladra.",
      },
      {
        task: "Marketing kép készítése",
        credits: "Kampányidőszakban",
        description: "Egyedi illusztráció poszthoz, bérlethez vagy workshop-hirdetéshez.",
      },
    ],
    chatFree: {
      title: "AI-asszisztens és AI-generálás — a csomag részeként",
      description:
        "Beszélgethetsz az AI-val marketing ötletekről, szövegeket írhattok együtt, generálhatsz posztot, képet vagy weboldalt — mindezt a csomagod részeként, a napi munkádhoz.",
    },
    chatFreeExamples: [
      "Marketing ötletelés, kampányterv",
      "Szövegek csiszolása, átírása",
      "Kérdések az AI-asszisztensről, beállítási segítség",
    ],
    monthlyIncluded: {
      title: "Mit tartalmaz mindkét csomag",
      standard: "Növekedés: AI-asszisztens a napi munkádhoz",
      pro: "Prémium: AI-asszisztens + több felhasználó, prioritásos támogatás",
      overflow:
        "Nincs külön AI-díj, nincs kreditszámlálás — használd a csomagod keretei között, amikor és amire szükséged van.",
    },
    creditsRollover: {
      title: "",
      description: "",
    },
    freeBadge: "3 napos ingyenes próba",
    freeNote:
      "Regisztráció után 3 napig teljes hozzáférést kapsz az AI-asszisztenshez és minden funkcióhoz — bankkártya nem kell.",
    packagesTitle: "",
    packagesIntro: "",
    oneTimeNote: "",
  },
  benefits: {
    heading: "Miért éri meg TSMT® terapeutaként?",
    items: [
      {
        title: "Saját weboldal",
        description:
          "Professzionális, saját weboldalad van online foglalással — nincs külön oldalkészítő, nincs telepítés.",
      },
      {
        title: "Órák és bérletek egyszerűen",
        description:
          "Torna‑ és mozgásfejlesztő órák előfoglalása, csomagok és bérletek automatikus kezelése.",
      },
      {
        title: "Otthoni gyakorlatok kiosztása",
        description:
          "Egy kattintással kioszthatod a szülőknek az otthoni gyakorlatokat — mindig a saját ügyfélportáljukon látják.",
      },
      {
        title: "Számlázás és kártyás fizetés",
        description:
          "Számlázz.hu integráció és online kártyás fizetés — a papírmunka automatizálva.",
      },
      {
        title: "GDPR + EU szerver",
        description:
          "Adataitokat EU‑s szervereken tároljuk, sosem használjuk AI tanításra, és nem adjuk el.",
      },
    ],
  },
  replaces: {
    heading: "Mit vált ki a Bespire?",
    description:
      "Külön naptár, üzenetküldő, weboldal, hírlevél és kézi időpont felvitele az LTSZ‑be helyett — egy AI asszisztens.",
    leftLabel: "Külön eszközök nélkül",
    rightLabel: "Bespire‑rel",
    unified: "Egyetlen rendszer — minden funkcióval együtt",
    aiBonus: "AI asszisztens — segít sikeresebb terapeutává válni",
    rightItems: [
      "Naptár + online foglalás egyben",
      "Saját weboldal és domain",
      "Automata LTSZ integráció",
      "AI marketing asszisztens",
      "Beépített üzenetküldés és hírlevelek",
    ],
    items: [
      "Külön naptár‑ és foglalási alkalmazás",
      "Weboldal‑szolgáltató és domain kezelés",
      "Kézi időpont felvitele az LTSZ‑be",
      "Külön marketing / közösségi média eszközök",
      "Külön hírlevél‑küldő",
    ],
  },
  continuousSupport: {
    eyebrow: "Támogatás",
    heading: "Nem maradsz egyedül az AI asszisztenssel",
    description:
      "Folyamatosan szervezünk dedikált workshopokat TSMT® terapeutáknak, ahol segítünk az AI asszisztens használatában, válaszolunk a felmerülő kérdésekre, és a terapeuták egymással is megoszthatják az ötleteiket.",
    webinarLink: "/tsmt-webinar",
    webinarLabel: "Jelentkezem online workshopra",
    items: [
      {
        title: "Dedikált TSMT® workshopok",
        description:
          "Rendszeres, csak TSMT® terapeutáknak szóló események — ahol az AI asszisztens minden funkcióját közösen fedezhetitek fel.",
      },
      {
        title: "Élő kérdések és válaszok",
        description:
          "A felmerülő problémákra helyben válaszolunk — legyen szó foglalásról, LTSZ szinkronról vagy marketingről.",
      },
      {
        title: "Gyakorlati asszisztenshasználat",
        description:
          "Konkrét tippek, trükkök és beállítások a mindennapi terápiás munkához — nem csak elmélet, hanem gyakorlat.",
      },
      {
        title: "Közösségi ötletmegosztás",
        description:
          "Tapasztalatcsere terapeutáktól terapeutáknak — hogyan használjátok a Bespire‑t a saját gyakorlatotokban.",
      },
    ],
  },
  howToStart: {
    heading: "Hogyan indulsz?",
    subheading: "Két út közül választhatsz — mindkettőnél a partneri kedvezmény már az első hónaptól él.",
    paths: [
      {
        badge: "Magadtól",
        title: "Indulj 3 napos ingyenes próbával",
        duration: "≈ 10 perc",
        description:
          "Regisztrálsz, azonnal kipróbálhatod az AI-asszisztenst 3 napig, teljes hozzáféréssel — vagy eljöhetsz egy online workshopra. A TSMT® nyilvántartási számot csak a végén, a partneri kedvezmény aktiválásához kell megadnod.",
        steps: [
          "Regisztrálsz a Bespire‑ben",
          "3 napig teljes hozzáférés — azonnal kipróbálhatod",
          "Eljöhetsz egy online workshopra vagy beállítod magad",
          "A végén megadod a TSMT® nyilvántartási számodat a kedvezményhez",
        ],
        cta: "Kipróbálom ingyen",
        ctaHref: "/onboarding",
      },
      {
        badge: "Velünk",
        title: "Beüzemeljük neked",
        duration: "≈ 1 munkanap",
        description:
          "Visszahívunk, egyeztetjük a részleteket és mi állítjuk össze az AI asszisztensed — egyszeri 50 000 Ft + ÁFA beüzemelési díj ellenében. Te csak elkezded használni.",
        steps: [
          "Kérsz visszahívást",
          "Egyeztetjük az igényeidet telefonon",
          "Összerakjuk a weboldalt, naptárat, LTSZ szinkront",
          "Átadjuk kulcsrakészen — mehet az első kliens",
        ],
        cta: "Kérek visszahívást",
        ctaHref: "/smb-pricing#callback",
      },
    ],
  },
  video: {
    heading: "„Végre egy AI asszisztens, ami tényleg segít.”",
    description:
      "Nézd meg Gonda‑Geszler Cili terapeuta véleményét a Bespire‑ről — miért kezdte használni és mit változott meg nála.",
  },
  faq: {
    heading: "Gyakori kérdések TSMT® terapeutáktól",
    items: [
      {
        q: "Hogyan igazoljuk a TSMT® nyilvántartási számot?",
        a: "Az igénylési űrlapon megadod a nyilvántartási számot. Röviden egyeztetünk telefonon, ellenőrizzük a jogosultságot, majd aktiváljuk a partneri kedvezményt a fiókodban.",
      },
      {
        q: "Hogyan működik az LTSZ integráció? Kell hozzá beállítanom valamit?",
        a: "Nem. A beüzemelés részeként mi kapcsoljuk össze — utána a weboldaladon lefoglalt időpontok automatikusan megjelennek az LTSZ‑ben.",
      },
      {
        q: "Mi történik a 2. év után?",
        a: "A 3. évtől a normál Bespire árat fizeted (havi vagy éves elszámolással, ahogy szeretnéd). Ez már így is kedvezőbb, mintha külön eszközöket használnál.",
      },
      {
        q: "Havi vagy éves fizetéssel is jár a kedvezmény?",
        a: "Igen, mindkettőre érvényes. Éves fizetésnél 2 hónapot elengedünk (havi × 10), és ez kombinálható a partneri kedvezménnyel.",
      },
      {
        q: "Van felmondás?",
        a: "Bármikor lemondhatod, nincs hosszú távú elköteleződés — a következő fizetési ciklusig marad aktív.",
      },
      {
        q: "Mennyi a próbaidő?",
        a: "3 napig ingyen kipróbálhatod, az AI-asszisztens teljes hozzáféréssel. Kártya nem szükséges, bármikor lemondhatod.",
      },
    ],
  },
  finalCta: {
    heading: "Kezdd el ingyen",
    description:
      "Indítsd el a Bespire‑t 3 napig ingyen, az AI-asszisztens teljes hozzáféréssel — kártya nélkül, bármikor lemondhatod. TSMT® kedvezmény aktiválható a próba alatt.",
    ctaPrimary: "Ingyenes indulás",
    ctaSecondary: "Beszéljünk telefonon",
  },
};
